import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import OurExtensiveBanner from '../../../assets/about-us/our-extensive-banner.png'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMOurExtensive: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingTop: '60px',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
            }}
        >

            <Box>
                <Image src={OurExtensiveBanner} width={isTablet ? 460 : 556} height={isTablet ? 430 : 520} alt='' style={{ objectFit: 'cover', borderRadius: '10px' }} preview={false}></Image>
            </Box>

            <Box sx={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: isTablet ? '20px' : '48px',
            }}>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'}>
                    {t('t105')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={isTablet ? '20px' : '40px'}>
                    {t('t106')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={isTablet ? '20px' : '40px'}>
                    {t('t107')}
                </Typography>

            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMOurExtensive
